import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.widget.as.waiting');
import { Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-afterservice-widget-as-waiting',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.afterservice.widget.as.waiting/view.scss */
/* src/app/portal.afterservice.widget.as.waiting/view.scss: no such file or directory */`],
})
export class PortalAfterserviceWidgetAsWaitingComponent implements OnInit {

  @Input() list: any[] = [];

  moment = moment;

  constructor(@Inject( Router)     private router: Router,@Inject( Service  )     public service: Service  ) {}

  async ngOnInit() {
    await this.service.init();
    await this.service.render(); 
  }

  public getView(id) {
    this.router.navigate(['/admin/as/view', id]);
  }
}

export default PortalAfterserviceWidgetAsWaitingComponent;